const c = {
  id: "yScaleTitlePlugin",
  afterDatasetsDraw: (e, i, l) => {
    const {
      ctx: t,
      chartArea: { top: a }
    } = e, { title: r, enabled: s } = l;
    s && (t.save(), t.fillStyle = "#606060", t.fillText(r || "", 5, a - 20), t.restore());
  }
};
export {
  c as default
};
//# sourceMappingURL=index.es166.js.map
